import {
  updateUserAddress as updateUserAddressApi,
  getUserFamily as getUserFamilyApi,
  getUserFamilyDonations as getUserFamilyDonationsApi,
  getUserMessages as getUserMessagesApi,
  checkMobileEligibility as checkMobileEligibilityApi,
  notifyMobileLinked as notifyMobileLinkedApi,
  updatePassword as updatePasswordApi
} from "./SpatApi";
import { showErrorToast, showSuccessToast } from "../utils/Toasts";


// Update user address
export async function updateUserAddress(data) {
  try {
    const response = await updateUserAddressApi(data);
    if (response?.status === 201 || response?.status === 200) {
      showSuccessToast(response?.data?.message || "முகவரி வெற்றிகரமாக புதுப்பிக்கப்பட்டது.");
      return true; // Return true on success
    } else {
      showErrorToast(response?.data?.message || response?.message || "ஏதோ தவறாகிவிட்டது");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "ஏதோ தவறாகிவிட்டது");
    return false;
  }
}


export async function getUserFamily(email) {
  try {
    const response = await getUserFamilyApi(email);
    if (response?.status === 201 || response?.status === 200) {
      return response.data;
    } else {
      showErrorToast(response?.data?.message || response?.message || "Failed to fetch user data");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Error fetching user details");
    return false;
  }
}

export async function getUserFamilyDonations(email) {
  try {
    const response = await getUserFamilyDonationsApi(email);
    if (response?.status === 201 || response?.status === 200) {
      return response.data;
    } else {
      showErrorToast(response?.data?.message || response?.message || "Failed to fetch user data");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Error fetching user details");
    return false;
  }
}

export async function getUserMessages(email) {
  try {
    const response = await getUserMessagesApi(email);
    if (response?.status === 201 || response?.status === 200) {
      return response.data;
    } else {
      showErrorToast(response?.data?.message || response?.message || "Failed to fetch user messages");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Error fetching user messages");
    return false;
  }
}

export async function checkMobileEligibility(data) {
  try {
    const response = await checkMobileEligibilityApi(data);
    if (response?.status === 201 || response?.status === 200) {

      return response.data;
    } else {
      showErrorToast(response?.data?.message || response?.message || "ஏதோ தவறாகிவிட்டது");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "ஏதோ தவறாகிவிட்டது");
    return false;
  }
}

export async function notifyMobileLinked(data) {
  try {
    const response = await notifyMobileLinkedApi(data);
    if (response?.status === 201 || response?.status === 200) {
      return response.data;
    } else {
      showErrorToast(response?.data?.message || response?.message || "ஏதோ தவறாகிவிட்டது");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "ஏதோ தவறாகிவிட்டது");
    return false;
  }
}

export async function updatePassword(data) {
  try {
    const response = await updatePasswordApi(data);
    if (response?.status === 201 || response?.status === 200) {

      return true; // Return true on success
    } else {
      showErrorToast(response?.data?.message || response?.message || "ஏதோ தவறாகிவிட்டது");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "ஏதோ தவறாகிவிட்டது");
    return false;
  }
}
